



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import NavbarWorkspacesMenu from '@/views/layout/navigation/navbar-workspaces-menu.vue';
@Component({
  components: {
    NavbarWorkspacesMenu
  }
})
export default class NavbarWorkspaces extends Vue  {
  menu: boolean = false;

  @Prop({ default: '' })
  contentClass: string;

  @Prop()
  nudgeLeft: number;

  @Prop()
  nudgeRight: number;

  @Prop()
  nudgeTop: number;

  @Prop()
  nudgeBottom: number;

  @Prop()
  offsetX: boolean;

  @Prop()
  offsetY: boolean;

  @Prop()
  closeMenu: any;

  closeMenuNav(){
    if(this.closeMenu){
      this.closeMenu();
    }
    this.menu=false;
  }
}
